import React from 'react';
import { Button } from '../../ui/Button';
import { Select } from '../../ui/Select';
interface IncomeTransactionsScreenProps {
  annualRevenue: string;
  monthlyTransactions: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function IncomeTransactionsScreen({
  annualRevenue,
  monthlyTransactions,
  onChange,
  onNext,
  onBack
}: IncomeTransactionsScreenProps) {
  const isValid = annualRevenue !== '' && monthlyTransactions !== '';
  const revenueOptions = [{
    value: 'under_50k',
    label: 'Less than $50,000'
  }, {
    value: '50k_100k',
    label: '$50,000 - $100,000'
  }, {
    value: '100k_500k',
    label: '$100,000 - $500,000'
  }, {
    value: '500k_1m',
    label: '$500,000 - $1,000,000'
  }, {
    value: '1m_5m',
    label: '$1,000,000 - $5,000,000'
  }, {
    value: 'over_5m',
    label: 'Over $5,000,000'
  }];
  const transactionOptions = [{
    value: 'under_50',
    label: 'Less than 50 transactions'
  }, {
    value: '50_200',
    label: '50 - 200 transactions'
  }, {
    value: '200_500',
    label: '200 - 500 transactions'
  }, {
    value: '500_1000',
    label: '500 - 1,000 transactions'
  }, {
    value: '1000_5000',
    label: '1,000 - 5,000 transactions'
  }, {
    value: 'over_5000',
    label: 'Over 5,000 transactions'
  }];
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-186">
      <div className="flex-1" data-id="element-187">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-188">
          Financial Activity
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-189">
          Help us understand your expected business activity.
        </p>

        <div className="space-y-6" data-id="element-190">
          <Select label="Estimated Annual Revenue" options={revenueOptions} value={annualRevenue} onChange={e => onChange('annualRevenue', e.target.value)} data-id="element-191" />
          <Select label="Monthly Transaction Volume" options={transactionOptions} value={monthlyTransactions} onChange={e => onChange('monthlyTransactions', e.target.value)} data-id="element-192" />
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-193">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-194">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-195">
          Review
        </Button>
      </div>
    </div>;
}